import { render, staticRenderFns } from "./IndirectServicesNotes.vue?vue&type=template&id=b70a7da0"
import script from "./IndirectServicesNotes.vue?vue&type=script&lang=js"
export * from "./IndirectServicesNotes.vue?vue&type=script&lang=js"
import style0 from "./IndirectServicesNotes.vue?vue&type=style&index=0&id=b70a7da0&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports